module.exports = __webpack_public_path__ + "static/intertec_product_2-30e865507665ae556ecb5328b29ca300.avif";